// extracted by css-extract-rspack-plugin
export default {"calendarIcon":"Anchor-module__calendarIcon__VUKUY"};